define('GameDayCore/GDModel/ValueObjects/Plays/Plays',['require','exports','module','../ValueObjectFactory','extant/extant','../../../GDUtil/window/Logg','../../../GDUtil/dataMapping/GameStateUtil','../../../GDControl/GameModelLocator/GameModelLocator','gameday-resource-path/gameday-resource-path','./AtBat','./PlaysFileOffense','./PlaysFileDefense'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant"),
        logg   = require( "../../../GDUtil/window/Logg" ),
        util = require("../../../GDUtil/dataMapping/GameStateUtil"),
        GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        resourcePath = require( 'gameday-resource-path/gameday-resource-path' );

	VO.create(Plays, {
		parseAtbat: function(data, batter, pitcher) {
			var atbat = data.atbat,
				action = data.action,
				AtBat = require('./AtBat'),
				homeOrAway = this.offense.type;

			if (!exists(atbat) && !exists(atbat)) {
				return null;
			} else if (typeof atbat != "object") {
				return new AtBat(action, data.inning);
			} else if (exists(pitcher) && exists(batter)) {
				//build a full at-bat object from the live data

				atbat.p_throws = pitcher.p_throws;
				atbat.b_height = batter.b_height;

				var atBatModel = new AtBat(atbat, data.inning);
				atBatModel.batter = batter.pid;
				atBatModel.batterUniform = batter.parent_team_abbrev||batter.team_abbrev;

				atBatModel.pitcher = pitcher.pid;
				atBatModel.stand = batter.stand || atbat.stand;
				atBatModel.b = data.b;
				atBatModel.s = data.s;
				atBatModel.o = data.o;
				atBatModel.inning = data.inning;

				return atBatModel;
			}

			return null;
		},
		parseLineup: function($team, lineup, battingOrder) {
			var teamObj = (lineup.team[0].type == $team) ? lineup.team[0] : lineup.team[1],
				pids = teamObj.man.splice(0, 9), // get array of players in the lineup
				teamArray = battingOrder,
				i, len;

			for (i = 0, len = pids.length; i < len; i++) {
				//overwrite the man objects with their pid sub-properties
				pids[i] = pids[i].pid;
			}

			//create an array of pids representing the current
			//batting order. Shift the lineup starting from the index
			//of the current batter.
			var battingOrderIdx = parseInt(teamObj.index);
			for (i = 0, len = pids.length; i < len; i++) {
				if (battingOrderIdx === len) {
					battingOrderIdx = 0;
				}

				teamArray.push(pids[battingOrderIdx]);
				battingOrderIdx++;
			}

			//add the pitcher last and return the array of pids
			pids.push(teamObj.pitcher);
			return pids;
		},
		findPlayer: function($pid) {
			if (!exists(this.playerArray)) {
				this.playerArray = [].concat(this.defense.man, this.offense.man || []);
			} else {
				$playerArray = [].concat($playerArray);
			}

			try {
				for (var i = 0, len = $playerArray.length; i < len; i++) {
					if ($playerArray[i].pid == $pid)
						return $playerArray[i];
				}
			} catch (e) {
				logg.error('findPlayer',e)
			}

			return null;
		},
		getLiveBatterAbs: function() {
			var ab = [];
			try {
				var ab_list = players.batter.ab;
				for (var i = 0, l = ab_list.length; i < l; i++) {
					if (exists(ab_list[i].inning) && exists(ab_list[i].event)) {
						a.push({inning: ab_list[i].inning, event: ab_list[i].event});
					}
				}
			} catch (e) {
				logg.error('Error retrieving atbat for live batter',e)
			}

			return ab;
		},
		findFieldPlayer: function($pid,defense) {
			return (exists(defense, "man")) ? this.findPlayer($pid) : null;
		},
		findBaseRunner: function($pid) {
			return (exists(this.offense, "man")) ? this.findPlayer($pid) : null;
		}
	});

	function Plays($data) {
		var vo = VO.ensureVO(this, Plays),
			data = $data,
			PlaysFileOffense = require('./PlaysFileOffense'),
			PlaysFileDefense = require('./PlaysFileDefense'),
			control = data.control,
			field = data.field,
			offense = (exists(field, "offense")) ? field.offense : {},
			defense = (exists(field, "defense")) ? field.defense : {},
			score = data.score,
			players = data.players,
			lineup = data.lineup,
			awayBattingOrder = [],
			homeBattingOrder = [],
			pitcher = (exists(players)) ? players.pitcher : {},
			batter = (exists(players)) ? players.batter : {},
			splits = data.splits,
			weather = data.weather;

		vo.gameItem = GameModelLocator.getCurrentGame();
		//situational
		vo.balls = data.b || "";
		vo.strikes = data.s || "";
		vo.outs = data.o || "";
		vo.gamestate = data.status || "";
		vo.status_ind = data.status_ind || "";
		vo.liveState = util.getUsableGameState(data.status_ind,true);
		vo.viewState = util.getUsableGameState(data.status_ind);
		vo.abstractGameState = util.getAbstractGamestate(data.status);
		vo.reason = data.reason || "";
		vo.inning = data.inning || "";
		vo.inning_state = data.inning_state || "";
		vo.half_inning = (data.top_inning === "T") ? "top" : "bottom";
		vo.isMidInning = (data.o === "3");
		vo.event = data.event || "";
		vo.team_batting = (offense) ? offense.type : "";
		vo.away_runs = (!!score) ? score.ar : "";
		vo.away_hits = (!!score) ? score.ah : "";
		vo.away_errors = (!!score) ? score.ae : "";
		vo.home_runs = (!!score) ? score.hr : "";
		vo.home_hits = (!!score) ? score.hh : "";
		vo.home_errors = (!!score) ? score.he : "";
		vo.game_includes_challenges = exists(data.review);
		vo.home_challenges_remain = data.review && ~~data.review.challenges_home_remaining > 0;
		vo.away_challenges_remain = data.review && ~~data.review.challenges_away_remaining > 0;
		vo.challenging_team = data.challenge_team_abbrev || null;
		vo.challenge_status = data.status_ind || null;
		//players
		vo.batter = batter;
		vo.pitcher = pitcher;
		vo.ondeck = (!!players && !!(players.deck)) ? players.deck.pid : "";
		vo.inhole = (!!players && !!(players.hole)) ? players.hole.pid : "";
		//splits
		vo.pitcher_splits = (!!splits) ? splits.pitcher : "";
		vo.batter_splits = (!!splits) ? splits.batter : "";
		vo.mob_splits = (!!splits) ? splits.runner : "";
		//weather
		vo.temp = (!!weather) ? weather.temp : "";
		vo.wind = (!!weather) ? weather.wind : "";
		vo.condition = (!!weather) ? weather.condition : "";
		//control
		vo.wait = (!!control) ? control.wait : "";
		vo.box = (!!control) ? control.box : "";
		//offense and defense models
		vo.offense = (exists(offense)) ? new PlaysFileOffense(offense) : null;
		vo.defense = (exists(defense)) ? new PlaysFileDefense(defense): null;

		//lineups
		vo.home_lineup = this.parseLineup("home", lineup, homeBattingOrder);
		vo.away_lineup = this.parseLineup("away", lineup, awayBattingOrder);
		//at-bat
		vo.atbat = this.parseAtbat(data, batter, pitcher);
		vo.ball = (exists(data, "field.ball.type")) ? data.field.ball : null;
		vo.awayBattingOrder = awayBattingOrder;
		vo.homeBattingOrder = homeBattingOrder;
	}

	return Plays;
});
